import C1 from "modules/ebiForms/definitions/C1";
import C2 from "modules/ebiForms/definitions/C2";
import C3 from "modules/ebiForms/definitions/C3";
import C4 from "modules/ebiForms/definitions/C4";
import C5 from "modules/ebiForms/definitions/C5";
import C6 from "modules/ebiForms/definitions/C6";
import C7 from "modules/ebiForms/definitions/C7";
import C9 from "modules/ebiForms/definitions/C9";
import { IEbiFormDefinition } from "modules/ebiForms/typings";

/** Pomoc społeczna i świadczenia: C1, C2, C3, C4, C5, C6, C7, C9 (docs/magistrat/ebi-wnioski). */
const FORMS: IEbiFormDefinition[] = [C1, C2, C3, C4, C5, C6, C7, C9];

export default FORMS;
